import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
// Types
import type { Header } from '@tanstack/react-table';

import Icon from '@/components/base/Icon';
// Components
import HeaderColumn from '@/components/base/Table/CompoundTable/TableHeader/HeaderColumn';

type DraggableColumnHeaderProps = {
    header: Header<unknown, unknown>;
};

function DraggableColumnHeader({ header }: DraggableColumnHeaderProps) {
    const { attributes, listeners, transform, transition, setNodeRef, isDragging, activeIndex } =
        useSortable({
            id: header.id
        });

    const style = {
        transform: CSS.Transform.toString(
            transform ? { x: transform.x, y: 0, scaleX: 1, scaleY: 1 } : null
        ),
        transition: transition
    };

    return (
        <HeaderColumn
            ref={setNodeRef}
            style={style}
            header={header}
            isDragging={isDragging}
            dragActivated={activeIndex !== -1}>
            <button
                data-testid={`compound-table-drag-and-drop-item-column-${header.id}`}
                className="invisible absolute left-2 top-1/2 z-1 flex -translate-y-1/2 cursor-grab group-hover:visible"
                {...attributes}
                {...listeners}>
                <Icon
                    icon="interface-drag"
                    className="text-xs text-icoGray-500 dark:text-icoDarkMode-wolf"
                />
            </button>
        </HeaderColumn>
    );
}

export default DraggableColumnHeader;
